import { MediaQueries } from 'custom_hooks/useWindowSize';
import { DashboardPageLayout } from 'pages/Dashboard/components/styled';
import styled from 'styled-components';

export {
    Card,
    CardContent,
    CardTitle,
    Header,
    HeaderControls,
} from 'pages/Dashboard/components/styled';

export const Page = styled(DashboardPageLayout)`
    display: grid;
    grid-template-areas:
        'head head head head'
        'value-counts   value-counts   value-counts   value-counts'
        'counts         deploy-scope   deploy-scope   value-by-type'
        'asset-coverage asset-coverage value-over-time value-over-time';
    grid-template-rows: var(--dashboard-header-height) 8rem minmax(30vh, 1fr) 1fr;
    grid-template-columns: 28rem 1fr 1fr 1fr;

    .head {
        grid-area: head;
        align-content: center;
        & > h1 {
            font-size: 2.4rem;
            line-height: 1.25;
        }
    }

    .counts {
        grid-area: counts;
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .value-counts {
        grid-area: value-counts;
        display: flex;
        flex-direction: row;
        gap: 1rem;
    }

    .deploy-scope {
        grid-area: deploy-scope;
    }

    .value-by-type {
        grid-area: value-by-type;
    }

    .asset-coverage {
        grid-area: asset-coverage;
    }

    .value-over-time {
        grid-area: value-over-time;
    }

    @media ${MediaQueries.largeAndDown} {
        grid-template-areas:
            'head'
            'value-counts'
            'counts'
            'deploy-scope'
            'value-by-type'
            'asset-coverage'
            'value-over-time';
        grid-template-columns: 1fr;
        grid-template-rows: auto;

        .value-counts {
            min-height: fit-content;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            align-content: space-around;
            & > * {
                height: fit-content;
                width: fit-content;
            }
        }

        .counts {
            display: flex;
            flex-direction: row;
            min-height: fit-content;
            align-items: center;
            justify-content: space-around;
            flex-wrap: wrap;
            & > * {
                height: fit-content;
                min-width: 20rem;
                flex-grow: 1;
            }
        }

        .deploy-scope {
            min-height: 40rem;
        }

        .value-by-type {
            min-height: 40rem;
        }

        .asset-coverage {
            min-height: 40rem;
        }

        .value-over-time {
            min-height: 40rem;
        }
    }
`;
